module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.07418adf.png";